.preview {
  display: contents;
  grid-row: bm-content-header / bm-content;
}

.preview-header {
  display: flex;
  grid-area: bm-content-header;
  gap: var(--mantine-spacing-sm);
  align-items: center;
  padding-block: var(--mantine-spacing-xs);
  padding-inline: var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-lg);
  background: var(--mantine-color-dark-7);
}

.content {
  display: flex;
  flex-flow: column nowrap;
  padding-block-start: var(--mantine-spacing-sm);
}

.dashboard {
  display: grid;
  flex: 1;
  margin: var(--mantine-spacing-md);
}

.description {
  padding-inline: var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-sm);
}
